import React, { useEffect, useState } from "react";
import "../login/login.css";
import images1 from "../../images/Carrymypet-01.png";
import images2 from "../../images/LoginScreen.png";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Cookies from "js-cookie";
import axios from "axios";
import Dashboard from "../SalesMasterPages/Dashboard/Dashboard";
import OpsDashboard from "../SalesMasterPages/DashboardTest/DashboardTest";
import Dashboardops from "../../pages/OperationMasterPages/DashboardOps/DashboardOps";
import FielsOpsDashboard from "../../components/FieldOperationsMiniDrawerMobile/fieldminiDrawer.jsx";
// import OperationDashboard from "../OperationMasterPages/OperationDashboard/OperationDashboard";
// import HRDashboard from "../HRMasterPages/HRDashboard/HRDashboard";
// import MasterDashboard from "../MasterPages/MasterDashboard/MasterDashboard";

import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginResponse, setLoginResponse] = useState(null);
  const [rememberMe, setRememberMe] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCheckboxChange = () => {
    setRememberMe(!rememberMe);
  };

  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const storedUserDetails = {
      name: localStorage.getItem("name"),
      designation: localStorage.getItem("designation"),
      is_sales: JSON.parse(localStorage.getItem("is_sales")),
      is_account: JSON.parse(localStorage.getItem("is_account")),
      is_operation: JSON.parse(localStorage.getItem("is_operation")),
      is_HR: JSON.parse(localStorage.getItem("is_HR")),
      is_master: JSON.parse(localStorage.getItem("is_master")),
      super_admin: JSON.parse(localStorage.getItem("super_admin")),
      Desg_ID: JSON.parse(localStorage.getItem("Desg_ID")),
    };
    const expirationTimeResponse = localStorage.getItem("tokenExpiration");

    if (storedToken && storedUserDetails && expirationTimeResponse) {
      setLoginResponse({ data: { access_token: storedToken } });
      setUserDetails(storedUserDetails);
    }

    const userName = Cookies.get("emailToken");
    const pwd = Cookies.get("passwordToken");
    if (userName) {
      setEmail(userName);
      setPassword(pwd);
    }

    loadCaptchaEnginge(4);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = {
      email: email,
      password: password,
    };

    if (validateCaptcha(captchaValue) === true) {
      if (rememberMe) {
        Cookies.set("emailToken", email, { expires: 7 });
        Cookies.set("passwordToken", password, { expires: 7 });
      }

      localStorage.setItem("credentials", JSON.stringify(requestBody));

      try {
        const response = await fetch(`${baseAPI}auth/weblogin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseData = await response.json();

        if (response.ok) {
          localStorage.setItem(
            "token",
            JSON.stringify(responseData.data.access_token),
          );
          localStorage.setItem(
            "tokenExpiration",
            responseData.data.endDateTime,
          );

          const userResponse = await axios.get(
            `${baseAPI}adminget/GETUserDetail`,
            {
              headers: {
                Authorization: `Bearer ${responseData.data.access_token}`,
              },
            },
          );

          const userData = userResponse.data.data[0];

          localStorage.setItem("name", userData.name);
          localStorage.setItem("designation", userData.Designation);
          localStorage.setItem("isAdmin", userData.is_admin);
          localStorage.setItem("Dept_ID", userData.Dept_ID);
          localStorage.setItem("Desg_ID", userData.Desg_ID);

          localStorage.setItem("is_sales", userData.is_sales);
          localStorage.setItem("is_account", userData.is_account);
          localStorage.setItem("is_operation", userData.is_operation);
          localStorage.setItem("is_HR", userData.is_HR);
          localStorage.setItem("is_master", userData.is_master);
          localStorage.setItem("super_admin", userData.super_admin);

          setUserDetails(userData);
          setLoginResponse(responseData);
        } else {
          alert("Login credential not matched!!");
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }
    } else {
      alert("Captcha Does Not Match");
    }
  };

  if (loginResponse && userDetails) {
    if (userDetails.is_sales) return <Dashboard />;
    if (userDetails.is_account) return <OpsDashboard />;
    if (userDetails.is_operation) return <Dashboardops />;
    if (userDetails.is_HR) return <OpsDashboard />;
    if (userDetails.is_master) return <OpsDashboard />;
    if (userDetails.Desg_ID==33 || userDetails.Desg_ID=="33") return <FielsOpsDashboard />;

    // Add a fallback return in case none of the conditions are true
    return <OpsDashboard />;
  } else {
    return (
      <>
        <div className="container-fluid-login">
          <div className="img-container"></div>

          <div className="form-container">
            <form onSubmit={handleSubmit} className="login-form">
              <img
                alt="Loading..."
                className="form-image"
                src={images1}
                style={{ background: "white" }}
              />
              <div className="form-group">
                <h4>Log In</h4>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="User Name"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <div className="form-group_ms" style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <a
                    className="eye-icon_ms"
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    <RemoveRedEyeIcon className="icon" />
                  </a>
                </div>
                <br />
                <div className="form-group">
                  <div
                    className="captcha-container"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <LoadCanvasTemplate />
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control"
                        value={captchaValue}
                        type="text"
                        onChange={(e) => setCaptchaValue(e.target.value)}
                        placeholder="enter captcha"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-main-class">
                <button type="submit" className="btn btn-primary btn-primary_ms">
                  Log In
                </button>

                <div
                  className="form-check"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="checkbox1"
                    name="rememberMe"
                    checked={rememberMe}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="checkbox1" className="form-check-label">
                    Remember me
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
        <style jsx>{`
          .button-main-class {
            margintop: 2rem;
            display: flex;
            justifycontent: space-between;
            alignitems: center;
            flexwrap: wrap; // helps on small screens
            gap: 10px;
          }
          .eye-icon_ms {
            position: absolute;
            right: 3.5%;
            top: 50%;
            transform: translateY(-50%);
            border: none;
            background: none;
            cursor: pointer;
          }
          @media (max-width: 768px) {
          .btn-primary_ms{
          width: 9rem;
          }
          .button-main-class{
          margin-top: 2rem;
    margin-left: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
          }
             h4 {
              font-size: 16px;
            }
            .login-form {
              // border: solid;
              // padding-top: 72px;
              // padding-bottom: 44px;
              // padding-left: 77px;
              // padding-right: 93px;
              // border-radius: 25px;
              // border-color: #878787;
              // width: 100%;
              // height: 54%;
            }
            .captcha-container {
              display: flex;
              justify-content: space-between;
              flex-direction: column;
            }

            .form-control {
              margin: 7px 7px 7px 0;
              height: 38px;
              width: 136%;
            }

            .form-group_ms a {
              position: absolute;
              right: -28.5%;
              top: 50%;
              transform: translateY(-50%);
              border-width: medium;
              border-style: none;
              border-color: currentcolor;
              border-image: initial;
              background: none;
              cursor: pointer;
            }
          }
        `}</style>
      </>
    );
  }
};

export default Login;
